import React from 'react';

const NavigationDofus = ({ active }) => {
    return (
        <div className='app__navigation'>
            {[
                'home',
                'sobre',
                'trabalhos',
                'habilidades',
                /* 'testimonials', */
                'contato',
            ].map((item, index) => (
                <a
                    href={`#${item}`}
                    key={item + index}
                    className='app__navigation-dot'
                    style={active === item ? { backgroundColor: '#b3ff00' } : {}}

                />
            ))}
        </div>
    )
}

export default NavigationDofus